import React from "react";
import { Input, Select, Button } from "antd";
import { SearchOutlined, PlusOutlined } from "@ant-design/icons";
import { translations } from "../../utils/Translation/staticTranslation";
import "./Discounts.css";

const { Option } = Select;

const DiscountFilters = ({
  searchValue,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  planTypeFilter,
  onPlanTypeFilterChange,
  onCreateDiscount,
  isReadOnly = false,
}) => {
  const lang = localStorage.getItem("language") || "ar";
  const t = translations[lang]?.discountsPage;

  return (
    <div className="discount-filters-container">
      <Input
        placeholder={t?.search_discounts || "Search by discount code"}
        prefix={<SearchOutlined className="discount-search-icon" />}
        value={searchValue}
        onChange={(e) => onSearchChange(e.target.value)}
        className="discount-search-input"
      />

      <div className="discount-filters-right">
        <Select
          value={statusFilter}
          onChange={onStatusFilterChange}
          className="discount-filter-select discount-filter-select-wrapper"
          size="large"
        >
          <Option value="All Status">
            {t?.filters?.all_status || "All Status"}
          </Option>
          <Option value="Active">
            {t?.filters?.status?.active || "Active"}
          </Option>
          <Option value="Expired">
            {t?.filters?.status?.expired || "Expired"}
          </Option>
          <Option value="Upcoming">
            {t?.filters?.status?.upcoming || "Upcoming"}
          </Option>
        </Select>

        <Select
          value={planTypeFilter}
          onChange={onPlanTypeFilterChange}
          className="discount-filter-select discount-filter-select-wrapper"
          size="large"
        >
          <Option value="All Plan Types">
            {t?.filters?.all_plan_types || "Plan Types"}
          </Option>
          <Option value="all">{t?.filters?.all_plans || "All Plans"}</Option>
          <Option value="Starter">
            {t?.filters?.plan_types?.starter || "Starter"}
          </Option>
          <Option value="Basic">
            {t?.filters?.plan_types?.basic || "Basic"}
          </Option>
          <Option value="Pro">{t?.filters?.plan_types?.pro || "Pro"}</Option>
          <Option value="Business">
            {t?.filters?.plan_types?.business || "Business"}
          </Option>
        </Select>

        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={onCreateDiscount}
          disabled={isReadOnly}
          title={
            isReadOnly
              ? t?.read_only_action_blocked ||
                "View only — you cannot create discounts."
              : undefined
          }
          className="discount-create-button"
        >
          {t?.create_discount || "Create Discount"}
        </Button>
      </div>
    </div>
  );
};

export default DiscountFilters;
